import { HttpMethod } from "../common/lib/fetch/useFetch";
import { RequestOptions } from "../common/lib/fetch/useRequest";
import useUserRequest from "../common/lib/fetch/useUserRequest";
import { User } from "../userAccess/UserContext";

export enum ScaleUsage {
  None = "None",
  Tare = "Tare",
  TareAndGross = "TareAndGross",
}

export enum ReceivingType {
  Scale = "Scale",
  Loadpass = "Loadpass",
  BulkReceiving = "BulkReceiving"
}

export interface BayScaleSettingsDto {
  id: string;
  name: string;
  scaleUsage: ScaleUsage;
  receivingType: ReceivingType;
}

export interface UpdateBayScaleSettingsDto extends Omit<BayScaleSettingsDto, "name">{};

export interface UpdateScaleAutomationSettings {
  minimumTareWeight: number | null;
  maximumTareWeight: number | null;
  minimumNetWeight: number | null;
  bayScaleSettings: UpdateBayScaleSettingsDto[];
}

export default function useUpdateScaleSettings(user: User, options?: RequestOptions) {
  return useUserRequest<UpdateScaleAutomationSettings>({
    path: `/api/sites/${user.selectedSite!.id}/scaleSettings`,
    method: HttpMethod.PUT
  }, options)
}
